import { render, staticRenderFns } from "./ArchivePanel.vue?vue&type=template&id=39248ac2&"
import script from "./ArchivePanel.vue?vue&type=script&lang=js&"
export * from "./ArchivePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('39248ac2', component.options)
    } else {
      api.reload('39248ac2', component.options)
    }
    module.hot.accept("./ArchivePanel.vue?vue&type=template&id=39248ac2&", function () {
      api.rerender('39248ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panels/ArchivePanel.vue"
export default component.exports